import { useTheme } from "@hooks";

export const DropDown = () => {
  const { theme } = useTheme();

  return (
    <svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.50033 7.25006L0.416992 0.202148H14.5837L7.50033 7.25006Z"
        fill={theme.icon.default}
      />
    </svg>
  );
};
